import { AxiosResponse } from 'axios'
import ErrorCode from 'forms/ErrorCodes'
import ValidationErrors from 'forms/ValidationErrors'
import validateMessage from './validateMessage'

const handleValidationError = (res: AxiosResponse): void | any => {
  const { code, payload } = res.data
  if (code !== ErrorCode.VALIDATION_ERRORS) return {}
  const errors = payload?.errors
  Object.keys(errors).forEach((key) => {
    errors[key] = errors[key].map((errorCode) => {
      const cd =
        validateMessage[ValidationErrors[errorCode]] || `error:${ValidationErrors[errorCode]}`
      return cd
    })
  })
  return errors || []
}

export default handleValidationError
